<template>
  <div>
    <b-card
      class="base__block"
      v-for="category in activeCategories()"
      :key="category.id"
    >
      <div class="base__block__header">
        <p
          class="base__block__header-title"
          :class="{ 'mr-auto': category.attach }"
        >
          {{ category.text }}
        </p>
        <div class="base__block__edit" v-if="access">
          <p v-b-modal.edit-category @click="getDataItem(category, 'item')">
            Изменить
          </p>
          <p
            class="color-red mar-left-15"
            v-if="admin"
            v-b-modal.delete
            @click="getDataForRemove(category.id, 'categories')"
          >
            Удалить
          </p>
        </div>
        <i
          class="pe-7s-pin pe-rotate-90 pe-lg mar-left-15"
          v-if="category.attach"
        ></i>
      </div>
      <ul class="base__block__category mar-top-15">
        <li
          class="base__block__category__links"
          v-for="link in activeExternalLinks(category.id)"
          :key="link.id"
        >
          <a :href="link.url" target="_blank">{{ link.title }}</a>
          <div class="base__block__edit" v-if="access">
            <p v-b-modal.edit-link @click="getDataItem(link, 'link')">
              Редактировать
            </p>
            <p
              class="color-red mar-left-15"
              v-b-modal.delete
              @click="getDataForRemove(link.id, 'links')"
            >
              Удалить
            </p>
          </div>
        </li>
      </ul>
      <div
        class="base__block__category"
        v-for="subCategory in activeSubCategories(category.id)"
        :key="subCategory.id"
      >
        <div class="base__block__category-title d-flex justify-content-between">
          <p
            v-b-toggle="`category_${category.id}-subCategory_${subCategory.id}`"
          >
            {{ subCategory.text }}
          </p>
          <div class="base__block__edit" v-if="access">
            <p
              v-b-modal.edit-subcategory
              @click="getDataItem(subCategory, 'item')"
            >
              Редактировать
            </p>
            <p
              class="color-red mar-left-15"
              v-if="admin"
              v-b-modal.delete
              @click="
                getDataForRemove(
                  { cat_id: category.id, subcat_id: subCategory.id },
                  'subcategories'
                )
              "
            >
              Удалить
            </p>
          </div>
        </div>
        <b-collapse
          :id="`category_${category.id}-subCategory_${subCategory.id}`"
        >
          <ul class="mar-top-15">
            <li
              class="base__block__category__links"
              v-for="link in activeLinks(subCategory.id, category.id)"
              :key="link.id"
            >
              <a :href="link.url" target="_blank">{{ link.title }}</a>
              <div class="base__block__edit" v-if="access">
                <p v-b-modal.edit-link @click="getDataItem(link, 'link')">
                  Редактировать
                </p>
                <p
                  class="color-red mar-left-15"
                  v-b-modal.delete
                  @click="getDataForRemove(link.id, 'links')"
                >
                  Удалить
                </p>
              </div>
            </li>
          </ul>
        </b-collapse>
      </div>
    </b-card>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  props: ["lists"],
  computed: {
    ...mapState("user", {
      admin: state => state.data.admin,
      access: state => state.data.access
    }),
    ...mapGetters("links", ["subCategories", "links"])
  },
  methods: {
    getDataItem(item, title) {
      this.$emit("getData", {
        data: item,
        title: title
      });
    },
    getDataForRemove(id, title) {
      this.$emit("removeData", {
        id: id,
        title: title
      });
    },
    activeCategories() {
      return this.lists.filter(item => {
        return (
          this.links.filter(link => link.cat_id === item.id && link.show)
            .length > 0
        );
      });
    },
    activeSubCategories(id) {
      return this.subCategories.filter(
        item => this.activeLinks(item.id, id).length > 0
      );
    },
    activeExternalLinks(id) {
      return this.links.filter(
        item => id === item.cat_id && item.subcat_id === null && item.show
      );
    },
    activeLinks(subCategory, category) {
      return this.links.filter(
        item =>
          category === item.cat_id &&
          subCategory === item.subcat_id &&
          item.show
      );
    }
  }
};
</script>
